import { render } from "./UiAudioUpload.vue?vue&type=template&id=585d7cc3&ts=true"
import script from "./UiAudioUpload.vue?vue&type=script&lang=ts&setup=true"
export * from "./UiAudioUpload.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/UiAudioUpload.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "585d7cc3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('585d7cc3', __exports__)) {
    api.reload('585d7cc3', __exports__)
  }
  
  module.hot.accept("./UiAudioUpload.vue?vue&type=template&id=585d7cc3&ts=true", () => {
    api.rerender('585d7cc3', render)
  })

}


export default __exports__